import { MedicalSummaryDto } from '@medone/medonehp-api-client';

// The MedicalSummary booleans that assert an absence (SCRUM-1301; noKnownSurgicalProcedures, SCRUM-1520). One list,
// because every rule about them applies to all of them; medical-summary-save.ts reads it too. A flag left off it is
// sent as null when untouched, and a note saved after it changed would put back the note's older copy.
export const absenceFlagNames = ['noKnownAllergies', 'noKnownMedications', 'noKnownProblems', 'noImmunizationHistory', 'noKnownSurgicalProcedures'] as const;

// SCRUM-1474: tooltip for an Add button one of these flags has disabled. It names the flag rather than
// saying "not available", because a disabled control with no stated cause is just a dead button. Every
// surface that can show a disabled Add also renders the checkbox itself, so naming it is enough — the
// user has something on screen to act on.
//
// Lives here rather than beside the checkbox component on purpose — it is a plain string, and importing
// it from that module would drag FormItemWithLock's auth chain into every consumer, including the
// standalone immunizations tab.
export const absenceFlagAddHint = (flagLabel: string): string => `Disabled while "${flagLabel}" is ticked.`;

// The generated C-CDA keeps "patient has none" and "no information available" apart, so an
// untouched absence checkbox has to reach the server as an explicit false, never as null. Every
// medical-summary save path funnels through here so the rule has one owner.
export const defaultAbsenceFlags = (medicalSummary: MedicalSummaryDto): void => {
    absenceFlagNames.forEach((flag) => {
        if (medicalSummary[flag] == null) {
            medicalSummary[flag] = false;
        }
    });
};
